// extracted by mini-css-extract-plugin
export default {"payment":"qxaOVVJ___payment","payment-mobile":"DPwSI04___payment-mobile","paymentMobile":"DPwSI04___payment-mobile"};